// config from RUM dashboard configuration JS snippet
export const RUM_BETA_CONFIG = {
    config: {
        sessionSampleRate: 1,
        guestRoleArn: 'arn:aws:iam::294214775213:role/musicpaperradwebsite-cognito-unauthenticated-role',
        identityPoolId: 'us-east-1:72c92f5e-f96a-42f1-a761-fd13e757a12d',
        endpoint: 'https://dataplane.rum.us-east-1.amazonaws.com',
        telemetries: ['errors', 'performance', 'http'],
        allowCookies: true,
        enableXRay: true
    },
    applicationId: '53a839d7-7218-4d0c-a7fe-1334c6015550',
    applicationVersion: '1.0.0',
    applicationRegion: 'us-east-1'
};

export const RUM_GAMMA_CONFIG = {
    config: {
        sessionSampleRate: 1,
        guestRoleArn: 'arn:aws:iam::450769666654:role/musicpaperradwebsite-cognito-unauthenticated-role',
        identityPoolId: 'us-east-1:69d0202b-3c56-4bd1-96a4-86e95e7445e5',
        endpoint: 'https://dataplane.rum.us-east-1.amazonaws.com',
        telemetries: ['errors', 'performance', 'http'],
        allowCookies: true,
        enableXRay: true
    },
    applicationId: '7a628612-f76e-491a-9fc1-671c32c9010a',
    applicationVersion: '1.0.0',
    applicationRegion: 'us-east-1'
};

export const RUM_PROD_CONFIG = {
    config: {
        sessionSampleRate: 1,
        guestRoleArn: 'arn:aws:iam::442032130814:role/musicpaperradwebsite-cognito-unauthenticated-role',
        identityPoolId: 'us-east-1:8973c6ec-d4e4-4ac3-ae1f-3c4b85fa9ffc',
        endpoint: 'https://dataplane.rum.us-east-1.amazonaws.com',
        telemetries: ['errors', 'performance', 'http'],
        allowCookies: true,
        enableXRay: true
    },
    applicationId: 'e82fe432-afc2-45c2-8cd9-4458c1c94474',
    applicationVersion: '1.0.0',
    applicationRegion: 'us-east-1'
};
